jQuery( function( $ ) {

	let $tableModal = null;
	const cartEndpoint = '/wp-json/wc/v2/cart';

	function TableModal(productId, productTitle, availableQuota, modalId) {
		return $(`
			<div class="reveal table-modal" id="${modalId}" data-reveal>
				
				<div class="modal-view view-form">
					<h1>${productTitle}</h1>
				  <p class="lead">Kuinka monta paikkaa haluat varata (vapaana <em>${availableQuota}</em>)?</p>
				  <form id="amountForm">
				  	<input type="number" class="amount-input" id="reservationAmount" min="1" max="${availableQuota}" placeholder="1" value="1" step="1" />
				  	<button class="button button-confirm-table-booking">Varaa</button>		  
				  </form>
				  <button class="close-button" data-close aria-label="Close reveal" type="button">
				    <span aria-hidden="true">&times;</span>
				  </button>
				</div>

				<div class="modal-view view-confirmation hide">
				 	<p class="lead">Paikat on nyt varattu, ja ne säilyvät ostoskorissasi 30 minuuttia ensimmäisestä varauksestasi. Viimeistelethän ostoksesi tänä aikana.</p>
				 	<!--<a class="tablemodal-continue-link button">Jatka eteenpäin</a>-->
				 	<a data-close-and-update aria-label="Close modal" class="button">Jatka</a>
				</div>

				<div class="modal-view view-error hide">
				 	<p class="lead">Paikkojen varaus epäonnistui. On mahdollista, että ne ehdittiin jo varata jonkun toisen toimesta. Voit palata varausnäkymään yrittääksesi uudelleen.</p>
				 	<button class="button" data-close-and-update aria-label="Close modal">Palaa takaisin</a>				 	
				</div>
			</div>
		`);
	}

	function removeModal() {

	}

	function showView(viewName) {
		$tableModal.find('.modal-view').addClass('hide');
		$tableModal.find('.view-'+viewName).removeClass('hide');
	}

	function disableModal() {
		$tableModal.addClass('modal-disabled');
	}

	function enableModal() {
		$tableModal.removeClass('modal-disabled');
	}

	function closeModalAndUpdateList() {
		$tableModal.foundation('close');
		$('#vmy-tables-content').addClass('tables-loading');
		$.get(window.location, function(data) {
	    	$('#vmy-tables-content').replaceWith($(data).find('#vmy-tables-content'));
		});
	}

	function updateList() {
		$.get(window.location, function(data) {
	    	$('#vmy-tables-content').replaceWith($(data).find('#vmy-tables-content'));
		});
	}

	function getRandomID() {
    var S4 = function() {
       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    };
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
	}

	$(document).on('click', '.vmy-tables .remove-table-from-cart', function(e) {
		e.preventDefault();
		$('#vmy-tables-content').addClass('tables-loading');
		const id = $(this).data('table-id');
		$.get('/wp-json/vmp/v1/cart-remove/?id='+id, 
			function(data, status) {
				console.log(data, status);
				updateList();
			}).fail(function(error) {
				console.log(error);
				$('#vmy-tables-content').removeClass('tables-loading');
			});
	});

	$(document).on('click', '.vmy-tables .button-book-table', function(e) {
		e.preventDefault();
		const id = $(this).data('table-id');
		const name = $(this).data('table-name');
		const availableQuota = $(this).data('table-quota');
		const cats = $(this).data('table-cats').split(',');
		const catIds = $(this).data('table-cat-ids').split(',');
    const catSlugs = $(this).data('table-cat-slugs').split(',');
		const modalId = 'modal-'+getRandomID();

		modal = new Foundation.Reveal(TableModal(id, name, availableQuota, modalId));
		modal.open();

		$tableModal = $('#'+modalId);
		$tableModal.find('.tablemodal-continue-link').click(function(e) {
			e.preventDefault();
			window.location.href = $("#vmp-settings").attr('data-next-page-url');
		});

		$tableModal.find("*[data-close-and-update]").click(function(e) {
			e.preventDefault();
			closeModalAndUpdateList();
		});

		$tableModal.find('.button-confirm-table-booking').click(function(e) {
			e.preventDefault();
			if ($tableModal.find('#reservationAmount').val() > availableQuota) {
				$tableModal.find('#reservationAmount').val(availableQuota);
				$tableModal.find('#reservationAmount').addClass('error');
			} else {
				disableModal();
				$.post(
					'/wp-json/wc/v2/cart/add',
					{
						product_id: id,
						quantity: $tableModal.find('#reservationAmount').val(),
						cart_item_data: { categoryIds: catIds, categoryNames: cats, categorySlugs: catSlugs}
					},
					function(data, status) {
						showView('confirmation');
						enableModal();
					}).fail(function(error) {
						console.log(error);
						showView('error');
						enableModal();
					});

			}

		});
	});

});
